import { Button } from '@retainerclub/common';
import PropTypes from 'prop-types';
import CurrentSubscriptionDetails from './CurrentSubscriptionDetails';
import CurrentSubscriptionDowngrade from './CurrentSubscriptionDowngrade';
import CurrentSubscriptionUpgrade from './CurrentSubscriptionUpgrade';

function ManageSubscriptionModalBodyMainView({
  subscription,
  handleUpgrade,
  handleDowngrade,
  handleCancel,
  subscriptionProducts,
}) {
  function getAvailableUpgrades() {
    return (
      subscriptionProducts
        ?.filter((tier) => {
          const tierPrice = tier.overPrice ? tier.price : tier.product.price;

          return (
            tierPrice > subscription.subscriptionPrice &&
            tier.product.id !== subscription.product.id
          );
        })
        .sort((a, b) => {
          const aPrice = a.overPrice ? a.price : a.product.price;
          const bPrice = b.overPrice ? b.price : b.product.price;

          return aPrice - bPrice;
        }) || []
    );
  }

  function getAvailableDowngrades() {
    return (
      subscriptionProducts
        ?.filter((tier) => {
          const tierPrice = tier.overPrice ? tier.price : tier.product.price;

          return tierPrice < subscription.subscriptionPrice;
        })
        .sort((a, b) => {
          const aPrice = a.overPrice ? a.price : a.product.price;
          const bPrice = b.overPrice ? b.price : b.product.price;

          return bPrice - aPrice;
        }) || []
    );
  }

  return (
    <div className="space-y-4">
      <CurrentSubscriptionDetails subscription={subscription} />

      <div className="space-y-4">
        <CurrentSubscriptionUpgrade
          upgrades={getAvailableUpgrades()}
          handleUpgrade={handleUpgrade}
        />

        <CurrentSubscriptionDowngrade
          downgrades={getAvailableDowngrades()}
          handleDowngrade={handleDowngrade}
        />

        <div className="border-gray-200 border-t pt-4">
          <Button
            name="Cancel Subscription"
            size="md"
            color="cancelOutline"
            rounded
            onClick={handleCancel}
          />
        </div>
      </div>
    </div>
  );
}

ManageSubscriptionModalBodyMainView.propTypes = {
  subscription: PropTypes.object.isRequired,
  handleUpgrade: PropTypes.func.isRequired,
  handleDowngrade: PropTypes.func.isRequired,
  handleCancel: PropTypes.func.isRequired,
  subscriptionProducts: PropTypes.array.isRequired,
};

export default ManageSubscriptionModalBodyMainView;
